<template>
  <v-container>
    <v-layout wrap>
      <v-flex sm12 md5 offset-md4>
        <v-card elevation="4" light tag="section">
          <v-card-title>
            <v-layout align-center justify-space-between>
              <h3 class="headline">
                {{ title }}
              </h3>
              <v-flex>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <p>Insira uma nova senha:</p>
            <v-form ref="changePasswordForm" v-model="valid" lazy-validation>
              <v-text-field
                outline
                label="Nova Senha"
                type="text"
                v-model="password"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[(v) => !!v || 'Informe a Senha',
                  (v) => (v && /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$#!%*#?&])[A-Za-z\d@$#!%*#?&]{6,}$/.test(v)) || 'Mínimo de 6 caracteres, 1 letra maúscula, 1 caractere especial, 1 número']"
                :type="show1 ? 'text' : 'password'"
                @click:append="show1 = !show1"
                required
              ></v-text-field>
              <v-text-field
                outline
                type="text"
                v-model="repeatPassword"
                label="Repita a Senha"
                :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[
                  (v) => !!v || 'Confirme a Senha',
                  (v) => (v === this.password) || 'As senhas devem ser idênticas']"
                :type="show2 ? 'text' : 'password'"
                @click:append="show2 = !show2"
                required
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions :class="{ 'pa-3': $vuetify.breakpoint.smAndUp }">
            <v-spacer></v-spacer>
            <v-btn
              color="info"
              :large="$vuetify.breakpoint.smAndUp"
              @click="change"
            >
              <v-icon left>lock</v-icon>
              Enviar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar v-model="errorMessage" color="error" timeout="5000"
      >Usuario ou senha incorretos.
    </v-snackbar>
  </v-container>
</template>

<script>
import { changeAsync } from "../services/loginService";

export default {
  name: "changePasswordForm",
  data: () => ({
    password: null,
    repeatPassword: null,
    title: "Primeiro Acesso",
    sending: false,
    show1: false,
    show2: false
  }),
  methods: {
    async change() {
      if (this.$refs.changePasswordForm.validate()) {
        try {
          await changeAsync(this.password);
          this.$router.push("/");
        } catch (e) {
          this.errorMessage = true;
        }
      }
    },
  },
};
</script>
